@use "../../styles/Colors.scss" as Colors;
@use "../../styles/Constants.scss" as Constants;

.time-zone {
	background: Colors.$col-blueBackground;
	padding: Constants.$val-spacing-s Constants.$val-spacing-m;
	font-size: Constants.$val-fontSizeSmall;
	color: Colors.$col-greyDark;
	display: flex;
	align-items: center;
	justify-content: space-between;

	&__banner {
		display: flex;
		align-items: center;

		b {
			margin: 0 Constants.$val-spacing-xs;
		}

		
		& > [class^="icon-clock"] {
			font-size: Constants.$val-fontSizeRegular;
			margin-right: Constants.$val-spacing-s;
			line-height: Constants.$val-fontSizeSmall;
		}
		
		& > [class^="icon-info"] {
			font-size: Constants.$val-fontSizeRegular;
			margin-left: Constants.$val-spacing-s;
			line-height: Constants.$val-fontSizeSmall;
		}
	}

	&__switch {
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}
}